/** Human-friendly role labels for the resolved profile role string. */
const ROLE_LABELS: Record<string, string> = {
  User: "User",
  Admin: "Admin",
  SystemAdmin: "System Admin",
  SalesPerson: "Sales",
  Client: "Client (consignee)",
  Finance: "Finance",
};

/** Org admins who can manage team, policies, and scheduled reports. */
export function isAdminRole(role?: string | null): boolean {
  return role === "Admin" || role === "SystemAdmin";
}

/** Resolve the best available display name from profile/Auth0 identity. */
export function resolveDisplayName(
  name?: string | null,
  email?: string | null,
): string {
  const trimmed = name?.trim();
  if (trimmed) return trimmed;
  if (email) return email;
  return "User";
}

/** First name (or the leading token) of a display name. */
export function firstName(displayName: string): string {
  return displayName.split(/\s+/)[0] || displayName;
}

/** Up-to-two-letter initials for an avatar fallback. */
export function initials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Display label for a role string, or null when unknown/absent. */
export function roleLabel(role?: string | null): string | null {
  if (!role) return null;
  return ROLE_LABELS[role] ?? role;
}
